import getCurrentLocale from "./features/i18n/utils/getCurrentLocale";
import groupTranslationImportsByLocale from "./features/i18n/utils/groupTranslationImportsByLocale";
import { loadTranslations } from "./features/i18n/utils/loadTranslations";

const LOCALE_LOADERS = groupTranslationImportsByLocale(
  import.meta.glob<Matice.Translations>("./locales/**/*.json", {
    import: "default",
  }),
);

export const LOCALES = Object.keys(LOCALE_LOADERS);
export const CURRENT_LOCALE = getCurrentLocale(LOCALES);

const createLocaleTestProxy = (prefix?: string): Matice.Translations =>
  new Proxy(
    {},
    {
      get(_target, prop) {
        if (typeof prop === "symbol") return undefined;
        if (prop !== "toString") return createLocaleTestProxy(prop);
        if (!prefix) return () => `{???}`;
        const head = prefix.split(".");
        let tail = head.pop()!;
        if (["title", "label", "description", "empty"].includes(tail)) {
          tail = `${head.pop()}.${tail}`;
        }
        const p = [...head.map((h) => h.charAt(0)), tail].join(".");
        return () => `{${p}}`;
      },
      has(_target, prop) {
        if (typeof prop === "symbol") return false;
        return true;
      },
    },
  );

export async function initTranslations() {
  const useFake =
    import.meta.env.DEV === true &&
    location.search.slice(1).split("&").includes("locale=test");
  const translations = useFake
    ? createLocaleTestProxy()
    : await loadTranslations(LOCALE_LOADERS[CURRENT_LOCALE]);
  globalThis.Matice = {
    locale: CURRENT_LOCALE,
    fallbackLocale: CURRENT_LOCALE,
    translations: {
      [CURRENT_LOCALE]: translations,
    },
  };
}
